// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".icon-title__icon{-webkit-box-flex:0!important;-ms-flex-positive:0!important;flex-grow:0!important}.icon-title__title{font-family:niveau-grotesk!important;font-weight:700}", ""]);
// Exports
module.exports = exports;
